<template>
  <v-expansion-panel @change="show_buttons = true">
    <v-expansion-panel-header>
      <v-layout>
        <v-flex>
          {{ f.name }}
        </v-flex>
        <v-flex style="text-align: right" v-show="show_buttons" xs1>
          <i
            class="fad fa-stream"
            style="margin-right:15px;"
            @click="
              (e) => {
                e.stopPropagation();
                log_dialog = true;
              }
            "
          ></i>
          <i
            class="fad fa-pen"
            @click="
              (e) => {
                e.stopPropagation();
                edit_dialog = true;
              }
            "
          ></i>
        </v-flex>
      </v-layout>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <p style="color: grey">{{ f.description }}</p>
      <v-layout row wrap>
        <v-flex sm6 xs12 style="padding-left: 10px; padding-right: 10px">
          <FunctionEvents :function_id="parseInt(f.id)"></FunctionEvents>
        </v-flex>
        <v-flex sm6 xs12 style="padding-left: 10px; padding-right: 10px">
          <FunctionUrls :function_id="parseInt(f.id)"></FunctionUrls>
        </v-flex>
      </v-layout>
      <v-dialog v-model="edit_dialog" max-width="590">
        <v-form @submit="editFunction">
          <v-card>
            <v-card-title>Edit function</v-card-title>
            <v-card-text>
              <v-text-field
                label="Name"
                aria-required="true"
                v-model="edit_name"
              ></v-text-field>
              <v-textarea v-model="edit_description"></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="error" @click="deleteFunction">Delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="default" @click="edit_dialog = false"
                >Cancel</v-btn
              >
              <v-btn text color="primary" type="submit">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <LogDialog v-model="log_dialog" :function_id="parseInt(f.id)" :function_name="f.name"></LogDialog>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { Functions } from "../../logic/Functions";
import { Notifications } from "../../notification";
import FunctionEvents from "./FunctionEvents";
import FunctionUrls from "./FunctionUrls";
import LogDialog from "./LogDialog";

export default {
  props: {
    f: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      edit_dialog: false,
      log_dialog: false,

      show_buttons: false,

      edit_name: this.f.name,
      edit_description: this.f.description,
    };
  },
  methods: {
    async editFunction(e) {
      e.preventDefault();

      var response = await Functions.edit(
        this.f.id,
        this.edit_name,
        this.edit_description
      );
      if (response.status === 200) {
        Notifications.show("The function has been updated.");
        this.$emit("functionUpdated");
        this.edit_dialog = false;
      } else {
        Notifications.show(response.message);
      }
    },
    async deleteFunction() {
      if (confirm("Do you really want to delete this function. This cannot be made undone.")) {
        var response = await Functions.delete(this.f.id);
        if (response.status === 200) {
          Notifications.show("The function has been deleted.");
        } else {
          Notifications.show(response.message);
        }
      }
    },
  },
  components: {
    FunctionEvents,
    FunctionUrls,
    LogDialog
  }
};
</script>

<style>
</style>